import React from 'react'

export default function RootsTechBannerBackground({
  children,
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  backgroundColor,
  additionalStyles = {},
}) {
  const bannerStyle = { ...additionalStyles }
  const hasImage = Boolean(backgroundImage)
  const hasColor = Boolean(backgroundColor)
  if (hasImage && hasColor) {
    bannerStyle.background = `url(${backgroundImage}) no-repeat ${backgroundPosition || 'center center'}, ${backgroundColor}`
    bannerStyle.backgroundSize = backgroundSize || 'cover'
  } else if (hasImage) {
    bannerStyle.backgroundImage = `url(${backgroundImage})`
    bannerStyle.backgroundRepeat = 'no-repeat'
    bannerStyle.backgroundPosition = backgroundPosition || 'center center'
    bannerStyle.backgroundSize = backgroundSize || 'cover'
  } else if (hasColor) {
    // background and not backgroundColor so that `linear-gradient(90deg, #00ADEE 0%, #C41A86 100%)` works
    bannerStyle.background = backgroundColor
  }

  return (
    <div data-cy="roots-tech-banner-background" style={bannerStyle}>
      {children}
    </div>
  )
}
